module.exports = __webpack_public_path__ + "img/4-half-md.ff561277.jpg";